<template>
  <div>
    <div class="company">
      <div class="profile" v-if="company_information">
        <div class="profile-left">
          <img :src="$url+company_information.picture" alt="" srcset="" />
        </div>
        <div class="profile-right">
          <div>
            <!-- <div class="profile-title">{{company_information.sub_title}}</div> -->
            <div class="profile-title-zh">{{company_information.name}}</div>
            <div class="profile-icon"></div>
            <p class="profile-text" v-html="company_information.content">
            </p>
          </div>
        </div>
      </div>

      <div class="profile profile2" v-if="business_philosophy">
        <div class="profile-right profile-rights">
          <div>
            <!-- <div class="profile-title">{{business_philosophy.sub_title}}</div> -->
            <div class="profile-title-zh">{{business_philosophy.title}}</div>
            <div class="profile-icon"></div>
            <p class="profile-text" v-html="business_philosophy.content">
            </p>
          </div>
        </div>
        <div class="profile-left">
          <img :src="$url+business_philosophy.picture" alt="" srcset="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Compony",
  data() {
    return {
      company_information: "",
      business_philosophy:''
    };
  },
  created() {
    this.$http
      .post("/index/news/detail", {
        type: "company_information",
      })
      .then((res) => {
        if (res.data.code == 0) {
          this.company_information = res.data.data;
        }
      });
          this.$http
      .post("/index/news/detail", {
        type: "business_philosophy",
      })
      .then((res) => {
        if (res.data.code == 0) {
          this.business_philosophy = res.data.data;
        }
      });


      
  },
};
</script>

<style lang="scss" scoped>
.company {
  margin: 0 auto;
  padding-top: 122px;
  width: 1220px;
  @media (min-width: 1024px) and (max-width: 1366px) {
    width: 1120px;
    padding-top: 122px;
  }
  // height: 1002px;
  // background-color: rgb(209, 149, 149);

  .profile2 {
    margin-top: 122px !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .profile {
    display: flex;
    align-items: center !important;
    justify-content: center !important;
    justify-content: flex-start;
    width: 1220px;
    height: 440px;
    @media (min-width: 1024px) and (max-width: 1366px) {
      width: 1120px;
      height: 400px;
    }
    .profile-left {
      width: 693px;
      height: 440px;
      @media (min-width: 1024px) and (max-width: 1366px) {
        width: 593px;
        height: 400px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }

    .profile-right {
      display: flex;
      align-items: center !important;
      justify-content: center !important;
      margin-left: 55px;
      width: 472px;
      font-size: 18px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      // line-height: 1.5;
      .profile-title {
        font-size: 24px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        // line-height: 0px;
      }
      .profile-title-zh {
        margin-top: 16px;
        font-size: 36px;
        @media (min-width: 1024px) and (max-width: 1366px) {
          font-size: 30px;
        }
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
      .profile-icon {
        margin-top: 16px;
        width: 272px;
        height: 8px;
        background: linear-gradient(
          90deg,
          #00a4a7 0%,
          rgba(0, 164, 167, 0) 100%
        );
        border-radius: 0px 0px 0px 0px;
      }
      .profile-text {
        margin-top: 30px;
        width: 474px;
        // height: 298px;
        font-size: 18px;
        @media (min-width: 1024px) and (max-width: 1366px) {
          font-size: 18px;
          line-height: 1.7;

        }
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 1.7;
      }
    }
    .profile-rights {
      margin-left: 0px !important;
      margin-right: 53px;
    }
  }
}

@media (max-width: 768px) {
  .company {
    margin: 0 auto;
    padding-top: 20px;
    width: 100%;
    // height: 1002px;
    // background-color: rgb(209, 149, 149);

    .profile {
      display: flex;
      flex-direction: column-reverse;
      align-items: center !important;
      justify-content: center !important;
      justify-content: flex-start;
      width: 100%;
      height: 100%;
      .profile-left {
        width: 90%;
        margin-top: 20px;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .profile-right {
        display: flex;
        align-items: center !important;
        justify-content: center !important;
        margin-left: 0px;
        width: 90%;
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        // line-height: 1.5;
        .profile-title {
          font-size: 24px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          // line-height: 0px;
        }
        .profile-title-zh {
          width: 100%;
          margin-top: 10px;
          font-size: 26px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #333333;
        }
        .profile-icon {
          margin-top: 16px;
          width: 272px;
          height: 8px;
          background: linear-gradient(
            90deg,
            #00a4a7 0%,
            rgba(0, 164, 167, 0) 100%
          );
          border-radius: 0px 0px 0px 0px;
        }
        .profile-text {
          margin-top: 30px;
          width: 100%;
          // height: 298px;
          font-size: 18px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 1.7;
          @media (min-width: 1024px) and (max-width: 1366px) {
            font-size: 18px;
            line-height: 1.7;
          }
        }
      }
      .profile-rights {
        margin-left: 0px !important;
        margin-right: 0px;
      }
    }
    .profile2 {
      margin-top: 40px !important;
      align-items: center !important;
      justify-content: center !important;
      flex-direction: column;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Compony.vue